import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { QUOTE_BLOCK } from '../constants';
import type { QuoteBlockElement } from '../types';

/** Whether the said block is a quote block or not. */
export const isQuoteBlock = isElementType<QuoteBlockElement>(QUOTE_BLOCK);
